import React, { FC, useState } from 'react';
import './ResultPane.scss';
import { IResultPaneProps } from './IResultPaneProps';
import Result from './Result/Result';


const ResultPane: FC<IResultPaneProps> = (props) => {
    const [downloading, setDownloading] = useState<boolean | undefined>(); 
    return (
        <div className="ResultPane">
            {props.results.map((result,idx) =>  {
                return <Result
                            otherIsDownloading={downloading!}
                            setDownloading={(newVal) => setDownloading(newVal)}
                            key={`resultPaneParent-${idx}`}
                            idx={idx}
                            result={result} />
            })}
        </div>
    );
}


export default ResultPane;
